import { useTheme } from '@/context/ThemeContext';

export default function ValueProposition() {
  const { isDark } = useTheme();

  const values = [
    {
      icon: 'ri-settings-3-line',
      title: 'Operational Automation',
      description: 'We eliminate repetitive operational tasks using intelligent automation and AI-driven workflows.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Decision Acceleration',
      description: 'Surface insights faster with automated reporting, data coordination, and real-time operational intelligence.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Infrastructure That Scales',
      description: 'Build systems designed for growth, allowing teams to operate more efficiently without adding complexity.',
    },
  ];

  return (
    <section
      className={`py-32 px-6 relative transition-colors duration-500 ${isDark ? 'bg-[#0D1B2A]' : 'bg-white'}`}
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#14B8A6]/30 to-transparent" />

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="text-[#14B8A6] text-xs font-semibold tracking-[0.2em] uppercase mb-6">
            WHY VILARIS
          </div>
          <h2 className={`text-5xl md:text-6xl font-bold mb-8 tracking-tight leading-[1.1] transition-colors duration-500 ${isDark ? 'text-white' : 'text-[#0D1B2A]'}`}>
            Systems That Keep Your<br />Business Moving
          </h2>
          <p className={`text-xl max-w-3xl mx-auto leading-relaxed transition-colors duration-500 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            Most businesses operate across disconnected systems, teams, and workflows. Vilaris AI builds an operational intelligence layer that connects these pieces into one coordinated structure.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className={`group relative backdrop-blur-xl rounded-3xl p-10 border transition-all duration-500 hover:scale-[1.02] cursor-pointer overflow-hidden ${
                isDark
                  ? 'bg-gradient-to-br from-[#1A2332]/40 to-[#0D1B2A]/40 border-white/5 hover:border-[#14B8A6]/30'
                  : 'bg-white border-gray-100 hover:border-[#14B8A6]/40 hover:shadow-xl'
              }`}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#14B8A6]/0 to-[#14B8A6]/0 group-hover:from-[#14B8A6]/5 group-hover:to-transparent transition-all duration-500 rounded-3xl" />
              <div className="relative z-10">
                <div className="w-16 h-16 flex items-center justify-center bg-[#14B8A6]/10 rounded-2xl mb-8 group-hover:bg-[#14B8A6]/20 transition-all duration-500 group-hover:scale-110">
                  <i className={`${value.icon} text-4xl text-[#14B8A6]`} />
                </div>
                <h3 className={`text-2xl font-bold mb-4 tracking-tight transition-colors duration-500 ${isDark ? 'text-white' : 'text-[#0D1B2A]'}`}>
                  {value.title}
                </h3>
                <p className={`text-base leading-relaxed transition-colors duration-500 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
